


















import Vue from 'vue';

import DialogCard from '@/components/DialogCard.vue';

export default Vue.extend({
  components: {
    DialogCard
  },

  props: {
    canDelete: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showDeleteMessage: false
    };
  },

  methods: {
    deleteIt() {
      if (this.canDelete) {
        this.$emit('delete');
      } else {
        this.showDeleteMessage = true;
      }
    },
    hideMessage() {
      this.showDeleteMessage = false;
    }
  }
});
